import { createI18n } from "vue-i18n";
import locales from "./locales";
import LocalStorage from "@/common/localstorage";

export const FALLBACK_LANGUAGE = "en";
export const DEFAULT_LANGUAGE = FALLBACK_LANGUAGE;
export const INITIAL_LANGUAGE = LocalStorage.get("language", DEFAULT_LANGUAGE);

export const i18n = createI18n({
  legacy: false,
  silentTranslationWarn: true,
  locale: INITIAL_LANGUAGE,
  fallbackLocale: FALLBACK_LANGUAGE,
  dateTimeFormats: locales.reduce((val, loc) => {
    if (!loc.dateTimeFormats) return val;
    val[loc.value] = loc.dateTimeFormats;
    return val;
  }, {}),
  messages: locales.reduce((val, loc) => {
    val[loc.value] = loc.localeApp;
    return val;
  }, {}),
});

export const ValidatorDictionaries = locales.reduce((val, loc) => {
  val[loc.value] = loc.localeValidator;
  return val;
}, {});

export default i18n;
